export enum EEstadoVenta {
  // VENTAS A CRÉDITO: esperando pagos
  PENDIENTE = 'PENDIENTE',

  // VENTA COMPLETAMENTE PAGADA: esperando emisión a SUNAT
  PENDIENTE_EMISION = 'PENDIENTE_EMISION',

  // ENVIADO A SUNAT: esperando respuesta
  SUNAT_PENDIENTE = 'SUNAT_PENDIENTE',

  // SUNAT RECHAZÓ
  SUNAT_RECHAZADO = 'SUNAT_RECHAZADO',

  SUNAT_AUTORIZADO_REEMISION = 'SUNAT_AUTORIZADO_REEMISION',

  // ANULACIÓN ENVIADA A SUNAT: esperando respuesta
  SUNAT_PENDIENTE_ANULACION = 'SUNAT_PENDIENTE_ANULACION',

  // SUNAT ACEPTÓ LA ANULACIÓN
  ANULADO = 'ANULADO',

  // FINALIZADO: SUNAT ACEPTÓ O NO REQUIERE SUNAT
  FINALIZADO = 'FINALIZADO',
}
